export const goodToKnowData = [
    "The luggage should be small and lightweight as a porter is not allowed to carry personal belongings.",
    "A deposit of 100% of the total price is required for reservation.",
    "Cancellation of booking in less than 30 days before arrival date, expect a 50% refund.",
    "Cancellation of booking in less than 15 days before arrival date, expect no refund.",
    "No refund for the participants who are unable to complete, attend or abandon the program due to any reason."
]